(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magnum-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.magnum-editorial[data-magnum-reveal]';
    const state = window.magnumEditorialState || {
      ready: false,
      observed: new WeakSet(),
      sections: new Set(),
      observer: null,
      scroller: null,
      ticking: false
    };

    window.magnumEditorialState = state;

    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const inView = (section) => {
      const rect = section.getBoundingClientRect();
      const height = window.innerHeight || document.documentElement.clientHeight;
      return rect.top < height * 0.84 && rect.bottom > height * 0.12;
    };

    const updateImageOffset = (section) => {
      const image = section.querySelector('[data-magnum-slide] img');

      if (!image) return;

      const rect = section.getBoundingClientRect();
      const height = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom < 0 || rect.top > height) return;

      const progress = (height - rect.top) / (height + rect.height);
      const offset = Math.max(-8, Math.min(8, (progress - 0.5) * 12));

      image.style.setProperty('--magnum-picture-y', `${offset.toFixed(2)}%`);
    };

    const reveal = (section) => {
      section.classList.add('is-visible');
      updateImageOffset(section);
    };

    const updateAll = () => {
      const reduce = reducedMotion();

      state.sections.forEach((section) => {
        if (reduce) {
          section.classList.remove('magnum-editorial--reveal-ready');
          reveal(section);
          return;
        }

        if (!section.classList.contains('is-visible') && inView(section)) {
          reveal(section);
        }

        updateImageOffset(section);
      });

      state.ticking = false;
    };

    const queueUpdate = () => {
      if (state.ticking) return;

      state.ticking = true;
      window.requestAnimationFrame(updateAll);
    };

    const bindScroller = () => {
      const scroller = document.querySelector('.page-wrapper');

      if (!scroller || state.scroller === scroller) return;

      if (state.scroller) {
        state.scroller.removeEventListener('scroll', queueUpdate);
      }

      state.scroller = scroller;
      state.scroller.addEventListener('scroll', queueUpdate, { passive: true });
    };

    const init = () => {
      const reduce = reducedMotion();

      bindScroller();

      document.querySelectorAll(selector).forEach((section) => {
        state.sections.add(section);

        if (reduce) {
          section.classList.remove('magnum-editorial--reveal-ready');
          reveal(section);
          return;
        }

        section.classList.add('magnum-editorial--reveal-ready');

        if (!state.observed.has(section)) {
          state.observed.add(section);

          if ('IntersectionObserver' in window) {
            if (!state.observer) {
              state.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;

                  reveal(entry.target);
                  state.observer.unobserve(entry.target);
                });
              }, { threshold: 0.18, rootMargin: '0px 0px -12% 0px' });
            }

            state.observer.observe(section);
          }
        }
      });

      queueUpdate();
    };

    if (!state.ready) {
      state.ready = true;
      window.addEventListener('scroll', queueUpdate, { passive: true });
      window.addEventListener('resize', queueUpdate);
      document.addEventListener('shopify:section:load', init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnum-grappa-cutout-fix"]) return;
  try {
    
  (() => {
    if (window.mgnGrappaCutoutFixReady) return;
    window.mgnGrappaCutoutFixReady = true;

    const quantSize = 16;
    const pixelIndex = (x, y, width) => (y * width + x) * 4;

    const candidateTolerance = (candidate) => {
      const brightness = (candidate[0] + candidate[1] + candidate[2]) / 3;
      if (brightness < 36) return 24 * 24;
      if (brightness > 218) return 42 * 42;
      return 46 * 46;
    };

    const addSample = (counts, data, index) => {
      if (data[index + 3] < 24) return;
      const key = [
        Math.round(data[index] / quantSize),
        Math.round(data[index + 1] / quantSize),
        Math.round(data[index + 2] / quantSize),
      ].join(",");
      counts.set(key, (counts.get(key) || 0) + 1);
    };

    const buildCandidates = (data, width, height) => {
      const counts = new Map();
      const step = Math.max(1, Math.floor(Math.min(width, height) / 160));

      for (let x = 0; x < width; x += step) {
        addSample(counts, data, pixelIndex(x, 0, width));
        addSample(counts, data, pixelIndex(x, height - 1, width));
      }

      for (let y = 0; y < height; y += step) {
        addSample(counts, data, pixelIndex(0, y, width));
        addSample(counts, data, pixelIndex(width - 1, y, width));
      }

      return [...counts.entries()]
        .sort((a, b) => b[1] - a[1])
        .slice(0, 8)
        .map(([key]) =>
          key.split(",").map((value) => Math.min(255, Number(value) * quantSize))
        );
    };

    const matchesBackground = (data, index, candidates) => {
      if (data[index + 3] < 24) return true;

      for (const candidate of candidates) {
        const red = data[index] - candidate[0];
        const green = data[index + 1] - candidate[1];
        const blue = data[index + 2] - candidate[2];

        if (red * red + green * green + blue * blue <= candidateTolerance(candidate)) {
          return true;
        }
      }

      return false;
    };

    const removeBackground = (canvas, context, width, height) => {
      const imageData = context.getImageData(0, 0, width, height);
      const { data } = imageData;
      const candidates = buildCandidates(data, width, height);
      if (!candidates.length) return false;

      const marked = new Uint8Array(width * height);
      const queue = [];
      let read = 0;

      const enqueue = (x, y) => {
        if (x < 0 || y < 0 || x >= width || y >= height) return;
        const position = y * width + x;
        if (marked[position]) return;
        if (!matchesBackground(data, position * 4, candidates)) return;
        marked[position] = 1;
        queue.push(position);
      };

      for (let x = 0; x < width; x += 1) {
        enqueue(x, 0);
        enqueue(x, height - 1);
      }

      for (let y = 0; y < height; y += 1) {
        enqueue(0, y);
        enqueue(width - 1, y);
      }

      while (read < queue.length) {
        const position = queue[read];
        read += 1;
        const x = position % width;
        const y = (position - x) / width;
        enqueue(x + 1, y);
        enqueue(x - 1, y);
        enqueue(x, y + 1);
        enqueue(x, y - 1);
      }

      if (queue.length < width * 2 + height * 2) return false;

      for (let position = 0; position < marked.length; position += 1) {
        if (marked[position]) data[position * 4 + 3] = 0;
      }

      context.putImageData(imageData, 0, 0);
      return true;
    };

    const processImage = (image) => {
      if (image.dataset.mgnGrappaCutout === "processing" || image.dataset.mgnGrappaCutout === "done") return;
      image.dataset.mgnGrappaCutout = "processing";

      const source = image.currentSrc || image.src;
      if (!source) return;

      const sourceImage = new Image();
      sourceImage.crossOrigin = "anonymous";
      sourceImage.decoding = "async";

      sourceImage.onload = () => {
        const width = sourceImage.naturalWidth;
        const height = sourceImage.naturalHeight;

        if (!width || !height) {
          image.dataset.mgnGrappaCutout = "failed";
          return;
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const context = canvas.getContext("2d", { willReadFrequently: true });
        if (!context) {
          image.dataset.mgnGrappaCutout = "failed";
          return;
        }

        try {
          context.drawImage(sourceImage, 0, 0);

          if (!removeBackground(canvas, context, width, height)) {
            image.dataset.mgnGrappaCutout = "failed";
            return;
          }

          canvas.toBlob((blob) => {
            if (!blob) {
              image.dataset.mgnGrappaCutout = "failed";
              return;
            }

            const url = URL.createObjectURL(blob);
            image.dataset.mgnGrappaCutout = "done";
            image.removeAttribute("srcset");
            image.classList.add("mgn-grappa-cutout-ready");
            image.addEventListener("load", () => URL.revokeObjectURL(url), { once: true });
            image.src = url;
          }, "image/png");
        } catch (error) {
          image.dataset.mgnGrappaCutout = "failed";
        }
      };

      sourceImage.onerror = () => {
        image.dataset.mgnGrappaCutout = "failed";
      };

      sourceImage.src = source;
    };

    const initCutoutMedia = () => {
      if (!document.querySelector(".mgn-grappa-cutout-fix")) return;

      document.querySelectorAll(".mgnc-card__media img").forEach((image) => {
        if (image.complete && image.naturalWidth) {
          processImage(image);
        } else {
          image.addEventListener("load", () => processImage(image), { once: true });
        }
      });
    };

    document.addEventListener("DOMContentLoaded", initCutoutMedia);
    document.addEventListener("shopify:section:load", initCutoutMedia);
    initCutoutMedia();
  })();

  } catch(e) { console.error(e); }
})();
})();
